import { ElMessageBox } from "element-plus";
import { h, VNode } from "vue";
import router from "@/router";

// TODO：モーダル表示のメッセージ等の処理など
export const messageBoxService = () => {
    const showConfirm = (
        title: string,
        message: string | string[],
        textConfirm: string,
        textCancel: string
    ) => {
        const resolvedMessage =
            Array.isArray(message)
                ? h('div', {}, message.map((line, index) =>
                    h('p', { style: 'margin: 0' }, line)
                ))
                : message
        return ElMessageBox.confirm(
            resolvedMessage,
            title,
            {
                confirmButtonText: textConfirm,
                cancelButtonText: textCancel,
                type: "warning"
            }
        )
    }

    const confirmDelete = (
        title: string,
        message: string | string[],
        textConfirm: string,
        textCancel: string
    ) => {
        const resolvedMessage =
            Array.isArray(message)
                ? h('div', {}, message.map((line, index) =>
                    h('p', { style: 'margin: 0' }, line)
                ))
                : message
        return ElMessageBox.confirm(
            resolvedMessage,
            title,
            {
                confirmButtonText: textConfirm,
                cancelButtonText: textCancel,
                type: "warning",
                confirmButtonClass: 'el-button--danger' // confirmボタンの色を削除ボタンを同じに
            }
        )
    }

    const showErrorModal = (
        errorTitle: string,
        errorText: string[] | null,
        errorLink: string | null,
        nextAction: string
    ) => {
        const messages:VNode[] = [];
        if (errorText != null) {
            errorText.forEach((text: string) => {
                const message = h('span', null, text);
                messages.push(message);
                messages.push(h('br'));
            });
        }

        ElMessageBox({
            title: errorTitle,
            message: h('p', null, messages),
            showCancelButton: false,
            confirmButtonText: nextAction == "googleAuth" ? "Googleアカウント認証画面を表示する" : 'OK',
            cancelButtonText: '',
            type: nextAction == "googleAuth" ? 'warning' : 'error',
            center: true,
            customClass: nextAction == "googleAuth" ? "google-auth" : "",
            beforeClose: (action, instance, done) => {
                if (action === 'confirm') {
                    switch (nextAction) {
                        case 'close':
                            break;
                        case 'logout':
                            router.push({name: 'Login'});
                            break;
                        case 'reload':
                            location.reload();
                            break;
                        case 'googleAuth':
                            if (errorLink !== null) {
                                window.open(errorLink, '_blank');
                            }
                            break;
                        default:
                            break;
                    }
                } else {
                    switch (nextAction) {
                        case 'close':
                            break;
                        case 'logout':
                            router.push({name: 'Login'});
                            break;
                        case 'reload':
                            location.reload();
                            break;
                        default:
                            break;
                    }
                }
                done()
            },
        })
    }

    return {
        showConfirm,
        confirmDelete,
        showErrorModal
    }
}
